import request from '@/utils/request';

export function getBase(ver, gainEid) {
    if (!gainEid) {
        gainEid = '';
    }
    return request({
        url: `/gains/base/${ver}/${gainEid}`,
        method: 'get'
    });
}

export function updateBase(ver, gainEid, data) {
    if (gainEid) {
        return request({
            url: `/gains/base/${gainEid}`,
            method: 'put',
            data: data
        });
    }

    return request({
        url: `/gains/base/${ver}`,
        method: 'post',
        data: data
    });
}